import { navItems } from "../data/navigation.js";
import { siteConfig } from "../data/seo.js";
import { withBase } from "../utils/sitePaths.js";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="brand-mark">CG</span>
          <div>
            <strong>ContiGO Freeze Foods</strong>
            <p>{siteConfig.tagline}</p>
          </div>
        </div>
        <nav aria-label="Footer navigation">
          {navItems.map((item) => (
            <a key={item.path} href={withBase(item.path)}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
      <p className="footer-note">
        Premium freeze-dried ingredients, botanicals and sourcing systems for global food ecosystems.
      </p>
    </footer>
  );
}
